<template>
    <transition name="fade">
        <div class="popup" :style="getPopupCss" @keyup.esc="onEscClick" :tabindex="0" ref="popup">
            <span :class="getCloseButtonClass"
                  class="popup-close-btn"
                  @click="onPopupCloseClick"
                  v-if="closeButton" />
            <div class="popup-header" v-if="header" :style="getHeaderStyle">{{ header }}</div>
            <slot name="content"></slot>
        </div>
    </transition>
</template>

<script>

    export default {

        props: {
            width: {
                type: Number,
                default: 300
            },
            height: {
                type: Number,
                default: 200
            },
            centeredX: {
                type: Boolean,
                default: true
            },
            centeredY: {
                type: Boolean,
                default: true
            },
            marginLeft: {
                type: Number,
                default: 0
            },
            marginTop: {
                type: Number,
                default: 0
            },
            closeButton: {
                type: Boolean,
                default: true
            },
            closeButtonType: {
                type: Number,
                default: 1
            },
            header: {
                type: String
            },
            headerColor: {
                default: '#46aaf6'
            },
            headerFontSize: {
                default: '15'
            },
            animate: {
                type: Boolean,
                default: false
            },
            closeOnBlur: {
                type: Boolean,
                default: false
            },
            closeOnEsc: {
                type: Boolean,
                default: false
            },
            backgroundColor: {
                type: String,
                default: 'white'
            },
            stretchWidth: {
                type: Boolean,
                default: false
            },
            stretchHeight: {
                type: Boolean,
                default: false
            },
            closeOnClick: {
                type: Boolean,
                default: true
            }
        },

        mounted() {
            // focus the popup, so we'll have the focusout functionality available immediately
            this.$refs.popup.focus();
        },

        methods: {

            close() {
                if (this.closeOnClick)
                    this.closePopup();

                this.$emit('close');
            },

            onPopupCloseClick() {
                this.close();
            },

            onEscClick() {
                if (this.closeOnEsc)
                    this.close();
            }

        },

        computed: {

            getHeaderStyle() {
                return {
                    'color': this.headerColor,
                    'font-size': this.headerFontSize + 'px'
                }
            },

            getCloseButtonClass() {
                switch (this.closeButtonType) {
                    case this.popupCloseButtonTypes.NORMAL:
                        return 'popup-close-btn-square-img';
                    case this.popupCloseButtonTypes.SQUARE:
                        return 'popup-close-btn-normal-img';
                    default:
                        throw 'invalid closeButtonType';
                }
            },

            getPopupCss() {

                let css = {};

                css = {
                    backgroundColor: this.backgroundColor
                };

                if (this.centeredX && this.centeredY)
                    css['-webkit-transform'] = 'translate(-50%, -50%)';
                else if (this.centeredX)
                    css['-webkit-transform'] = 'translateX(-50%)';
                else if (this.centeredY)
                    css['-webkit-transform'] = 'translateY(-50%)';


                if (this.centeredX) {
                    css.position = 'fixed';
                    css.left = '50%';
                }
                else {
                    css.marginLeft = this.marginLeft + 'px';
                    css.left = 0;
                }

                if (this.centeredY) {
                    css.position = 'fixed';
                    css.top = '50%';
                }
                else {
                    css.marginTop = this.marginTop + 'px';
                    css.top = 0;
                }

                if (!this.stretchWidth)
                    css.width = this.width + 'px';
                else
                    css.minWidth = this.width + 'px';

                if (!this.stretchHeight)
                    css.height = this.height + 'px';
                else
                    css.minHeight = this.height + 'px';

                if (!this.animate) {
                    css.transition = 'none';
                }

                return css;

            }

        }

    }

</script>

<style lang="scss" scoped>

    @import '../../../style/forms.scss';
    @import '../../../style/popup.scss';

    .fade-enter-active {
        transition: opacity .5s
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }

    .popup {
        background: white;
        z-index: 10000;
        font-family: Arial;
        padding: 30px 25px;
        overflow: hidden;
        position: fixed;
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/Popup/Popup.vue